import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { DeleteBusinessRepository } from '@/coreInfrastructureModule/Repositories/DeleteBusinessRepository';

/**
 *  取引削除用のUseCase
 */
export class DeleteAllBusinessForDebugMenuUseCase {
  /**
   * 取引情報の削除を行う（デバッグメニュー用）
   * @param repository - リポジトリ
   * @param useInitData - 初期データを流し込むかどうか
   */
  public Execute = async (repository: DeleteBusinessRepository, useInitData: boolean): Promise<INetworkResult<object, Error>> => {
    try {
      const result = await repository.deleteAllBusiness(useInitData);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }

      return {
        status: {
          type: 'success',
          data: result,
        },
      };
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  };
}
